import React, { useState, useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import Card from 'screens/shared/card-basic';
import { useSelector } from 'react-redux';
import { _t } from 'utils';
import Utils from 'screens/shared/utilities';
import Text from './input-field';

export default ({
  onChange = null,
}) => {
  const [items, setItems] = useState([]);
  const [filters, setFilers] = useState({
    search: '',
  });

  const { users = [] } = useSelector((e) => e);

  useEffect(() => {
    const usersWithoutAdmins = users.filter(({ properties: { administrator = false } }) => (!administrator));
    setItems([...usersWithoutAdmins.map((e) => ({ ...e, isSelected: false }))]);
  }, [users]);

  const setFilter = (valueParam) => setFilers((e) => ({ ...e, ...valueParam }));

  const onItemSelect = (item) => {
    item.isSelected = true;
    const updatedItems = items.map((e) => ({ ...e, isSelected: false }));
    const index = updatedItems.findIndex(({ id }) => id === item.id);
    updatedItems[index] = item;
    setItems([...updatedItems]);
    onChange(item);
  };

  let filteredItems = items;

  if (filters.search) {
    filteredItems = filteredItems
      .filter((
        { properties: { firstname = '', lastname = '' } },
      ) => ((`${firstname} ${lastname}`).toLowerCase().indexOf(filters.search.toLowerCase()) !== -1));
  }

  return (
    <div className="image-selector">
      <div className="image-selector-top">
        <Text
          label={_t('Search')}
          value={filters.search}
          onChange={(valueParam) => setFilter({ search: valueParam })}
        />
      </div>

      <div className="cards">
        {filteredItems.map((item) => {
          const {
            id, properties: { firstname, lastname, email }, isSelected = false,
          } = item;
          return (
            <Card
              key={id}
              className={!!isSelected && 'selected'}
              onClick={() => onItemSelect(item)}
              icon="user-tie"
              title={`${firstname} ${lastname}`}
              details={email}
              buttons={[]}
              isArrow={false}
            />
          );
        })}
        {(!!filters.search) && !filteredItems.length && <Utils.NoData />}
        {!users.length && <div className="empty"><CircularProgress style={{ width: 70, height: 70 }} className="loader" /></div>}
      </div>
    </div>
  );
};
